import React from "react";
import Footer from "./footer";

const Bending = () => {
  return (
    <React.Fragment>
      <div className="card rounded-3 shadow mx-lg-5 mx-md-3 mx-sm-1 my-4 p-xxl-5 py-3 text-center flex-fill">
        <h2>PENDING PAGE</h2>
        <div className="container w-75 ">
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </p>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default Bending;
